export default __webpack_public_path__ + "static/media/nft-card-back01.9ed989f0.png";